import { SERVER_COST_ROWS, SERVER_PLANS } from './pricingData';

// 인원 행(4개)과 별도 부담 행(3개) 수가 달라, 둘을 곱한 수만큼 줄을 나눠
// 인원은 SERVER_COST_ROWS.length줄씩, 별도 부담은 SERVER_PLANS.length줄씩 합친다
const GRID_ROWS = SERVER_PLANS.length * SERVER_COST_ROWS.length;
const PLAN_SPAN = GRID_ROWS / SERVER_PLANS.length;
const COST_SPAN = GRID_ROWS / SERVER_COST_ROWS.length;

// 요금 페이지(/price)와 메인 페이지 요금 섹션이 함께 쓰는 단독 서버 구축 요금표
export default function ServerPlanTable() {
  return (
    <div className="price-table-wrap reveal">
      <table className="price-table">
        <thead>
          <tr>
            <th rowSpan={2}>인원</th>
            <th rowSpan={2}>금액</th>
            <th colSpan={3}>별도 부담</th>
          </tr>
          <tr>
            <th className="sub-head">항목</th>
            <th className="sub-head">주기</th>
            <th className="sub-head">비용</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: GRID_ROWS }, (_, r) => {
            const plan = r % PLAN_SPAN === 0 ? SERVER_PLANS[r / PLAN_SPAN] : null;
            const cost = r % COST_SPAN === 0 ? SERVER_COST_ROWS[r / COST_SPAN] : null;
            return (
              <tr key={r}>
                {plan && (
                  <>
                    <td rowSpan={PLAN_SPAN}>{plan[0]}</td>
                    <td rowSpan={PLAN_SPAN}>{plan[1]}</td>
                  </>
                )}
                {cost && (
                  <>
                    <td rowSpan={COST_SPAN} className="cost-item">
                      {cost[0]}
                    </td>
                    <td rowSpan={COST_SPAN} className="cost-cell">
                      {cost[1]}
                    </td>
                    <td rowSpan={COST_SPAN} className="cost-cell">
                      {cost[2]}
                    </td>
                  </>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
